import { useEffect } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";

const GTM_ID = "GTM-TF28HRQF";

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export function GoogleTagManager() {
  const { hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasMarketingConsent) {
      return;
    }

    if (typeof window === "undefined") {
      return;
    }

    // Avoid injecting GTM more than once
    if (document.getElementById("gtm-script")) {
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    // Inject GTM script into <head>
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);

    // Inject GTM noscript fallback into <body>
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, [hasMarketingConsent]);

  return null;
}
